function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.609 1.732l-3.95 3.95a.995.995 0 01-.732.288.998.998 0 01-.732-.288l-3.95-3.95A1 1 0 012.659.317l3.268 3.268L9.195.317a1 1 0 011.414 1.415z"
});

var SvgDropTick = function SvgDropTick(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgMTEgNiI+CiAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjYwOSAxLjczMmwtMy45NSAzLjk1YS45OTUuOTk1IDAgMCAxLS43MzIuMjg4Ljk5OC45OTggMCAwIDEtLjczMi0uMjg4bC0zLjk1LTMuOTVBMSAxIDAgMCAxIDIuNjU5LjMxN2wzLjI2OCAzLjI2OEw5LjE5NS4zMTdhMSAxIDAgMCAxIDEuNDE0IDEuNDE1eiIvPgo8L3N2Zz4K";
export { SvgDropTick as ReactComponent };